import { useState, useEffect } from 'react'
import { formatDateForApi, DateFilters } from 'pixel-base'
import { get } from 'utils/api-routes.util'

interface CityData {
  city: string
  state: string
  country: string
  total_orders: number
  successful_orders: number
  returned_orders: number
  net_revenue: number
  returned_revenue: number
  avg_order_value: number
  unique_customers: number
  return_rate_percentage: number
  success_rate_percentage: number
  revenue_return_rate_percentage: number
  orders_per_customer: number
}

interface ChartFilters extends DateFilters {}

interface ApiResponse {
  data: CityData[]
  meta: {
    total: number
    period: {
      start_date: string
      end_date: string
    }
    sort_by: string
    filters: {
      include_deleted: boolean
      excluded_statuses: string[]
      include_archived: boolean
    }
  }
}

export const useDetailCitiesData = (
  filters: ChartFilters,
  enabled: boolean,
) => {
  const [cities, setCities] = useState<CityData[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setCities([])
      setLoading(false)
      return
    }

    setLoading(true)
    get('/dashboard/cities', {
      start_date: formatDateForApi(filters.start_date),
      end_date: formatDateForApi(filters.end_date),
      limit: -1,
    }).subscribe({
      next: (res: any) => {
        // Handle AjaxResponse format
        let responseData = null
        if (res && res.response && res.response.data) {
          responseData = res.response.data
        } else if (res && res.data) {
          responseData = res.data
        }

        if (responseData && Array.isArray(responseData)) {
          setCities(responseData)
        } else {
          setCities([])
        }
        setLoading(false)
      },
      error: (error) => {
        console.error('Error fetching cities data:', error)
        setCities([])
        setLoading(false)
      },
    })
  }, [filters.start_date, filters.end_date, enabled])

  return {
    cities,
    loading,
  }
}
